/**
 * Calendar types for ATS.
 */

export type CalendarEventStatus = 'scheduled' | 'completed' | 'cancelled';
export type CalendarLocationType = 'online' | 'offline';
export type CalendarAttendeeRole = 'interviewer' | 'hr' | 'attendee';

export interface CalendarAttendee {
  id: string;
  account_id: string | null;
  email: string | null;
  display_name: string;
  role: CalendarAttendeeRole;
  created_at: string;
}

export interface CalendarEvent {
  id: string;
  workspace_id: string;
  account_id: string | null;
  title: string;
  description: string | null;
  start_time: string;
  end_time: string;
  event_type_id: string | null;
  event_type_name: string | null;
  status: CalendarEventStatus;
  location_type: CalendarLocationType;
  location: string | null;
  cv_id: string | null;
  job_id: string | null;
  cv_name: string | null;
  job_code: string | null;
  job_position_name: string | null;
  attendees: CalendarAttendee[];
  template_email_sent_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface CalendarAttendeeCreateInput {
  account_id?: string;
  email?: string;
  display_name: string;
  role?: CalendarAttendeeRole;
}

export interface CalendarEventCreateInput {
  title: string;
  description?: string;
  start_time: string;
  end_time: string;
  event_type_id?: string;
  location_type?: CalendarLocationType;
  location?: string;
  cv_id?: string;
  job_id?: string;
  attendees?: CalendarAttendeeCreateInput[];
  template_id?: string;
  /** User-edited subject that overrides template rendering. */
  template_subject_override?: string;
  /** User-edited body HTML that overrides template rendering. */
  template_body_html_override?: string;
}

export interface CalendarEventUpdateInput {
  title?: string;
  description?: string;
  start_time?: string;
  end_time?: string;
  event_type_id?: string;
  status?: string;
  location_type?: string;
  location?: string;
  cv_id?: string;
  job_id?: string;
  attendees?: CalendarAttendeeCreateInput[];
  template_id?: string;
}

export interface CalendarEventListData {
  items: CalendarEvent[];
  total: number;
}

export interface CalendarEventResponse {
  success: boolean;
  data: CalendarEvent;
  message?: string;
}

export interface CalendarEventListResponse {
  success: boolean;
  data: CalendarEventListData;
  message?: string;
}

export const EVENT_STATUS_CONFIG: Record<CalendarEventStatus, { label: string; color: string }> = {
  scheduled: { label: 'Scheduled', color: 'bg-blue-100 text-blue-700' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-700' },
  cancelled: { label: 'Cancelled', color: 'bg-red-100 text-red-700' },
};

export const ATTENDEE_ROLE_CONFIG: Record<CalendarAttendeeRole, { label: string; color: string }> = {
  interviewer: { label: 'Interviewer', color: 'bg-blue-100 text-blue-700' },
  hr: { label: 'HR PIC', color: 'bg-orange-100 text-orange-700' },
  attendee: { label: 'Attendee', color: 'bg-gray-100 text-gray-700' },
};
